const type = [
  { id: 1, label: "律师催告函" },
  { id: 2, label: "律师询问函" },
  { id: 3, label: "律师答复函" },
  { id: 4, label: "其它律师函" },
];
export const rName = (t) => {
  if (t)
    return type.find((ele) => {
      return t == ele.id;
    }).label;
  else return "";
};
export const letters_type = type;

export const lawKeys = [
  "id",
  "letters_type",
  "title",
  "no",
  "receiver_debtor_id",
  "accuser_id",
  "files",
  "ship_no",
  "tel",
  "filename",
  "receive_name",
  "ship_time",
  "receive_time",
  "return_time",
  "addr",
  "comment",
];

export const deInfoKeys = [
  "id",
  "province_id",
  "city_id",
  "area_id",
  "comment",
  "addr",
  "chinaid",
  "realname",
  "phone",
  "sex",
  "relation",
  "type",
  "accuser_id",
];
